import { render, staticRenderFns } from "./profileBottom.vue?vue&type=template&id=323769b0&"
import script from "./profileBottom.vue?vue&type=script&lang=js&"
export * from "./profileBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports